import { Box, Button, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { changeUserPassword } from "../../../../../../../api/apiCall";
import { toast } from "react-toastify";
import { useAuth } from "../../../../../../../auth/auth";

const ChangePassword = ({userId}: any) => {
    const {state} = useAuth();
    const [password, setPassword] = useState<any>("");
    
    const changePassword = async () => {
        const response: any = await changeUserPassword(state.user?.token, password, userId);
        if(response.status === 200) {
            toast.success('Password Changed Successfully!');
            setPassword("")
        };
    }

    return (
        <Box sx={{maxWidth: 650, margin: "auto", backgroundColor: "#fff", padding: 5}}>
            <Typography fontWeight={"bold"} mb={2}>Change Password</Typography>
            <Box display={"flex"} justifyContent={"space-between"}>
                <TextField
                    label="Password"
                    type="password"
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <Button
                    variant="contained"
                    sx={{width: 300, ml: 2, boxShadow: "none"}}
                    onClick={changePassword}>Change Password</Button>
            </Box>
        </Box>
    )
}

export default ChangePassword;
